import React, { Suspense } from "react";
import { ContentRoute, LayoutSplashScreen } from "../../../_metronic/layout";
import { Redirect, Switch } from "react-router-dom";
import { ProjectManagementPage } from "./ProjectManagementTable/ProjectManagementPage";

 function ProjectManagement() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          <Redirect
            exact={true}
            from="/projects"
            to="/projects/projectManagementPage"
          />
        }
        <ContentRoute
          path="/projects/projectManagementPage"
          component={ProjectManagementPage}
        />
      </Switch>
    </Suspense>
  );
}

export default  ProjectManagement;
